import { Injectable } from '@angular/core';
import { FormBuilder, FormControl, FormArray, Validators, FormGroup, AbstractControl, ValidatorFn, ValidationErrors } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class PolicyService {

  constructor() { }

  patternValidator(regex: RegExp, error: ValidationErrors): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {

      if (!control.value) {
        return null;
      }
      const valid = regex.test(control.value);
      return valid ? null : error;
    };
  }

  passwordMatchValidator(control: AbstractControl) {
    const password: string = control.get('password').value; // get password from our password form control
    const confirmPassword: string = control.get('confirmPassword').value; // get password from our confirmPassword form control
    // compare is the password math
    // console.log("Policy Services Password",password)
    if (password !== confirmPassword) {
      // if they don't match, set an error in our confirmPassword form control
      control.get('confirmPassword').setErrors({ NoPassswordMatch: true });
    }


  }

  passwordMatchValidatorForReset(control: AbstractControl) {
    const confirmPassword: string = control.get('confirmPassword').value; // get password from our confirmPassword form control
    const newPassword: string = control.get('newPassword').value
    // compare is the password math

    if (newPassword && newPassword !== confirmPassword) {
      control.get('confirmPassword').setErrors({ NoPassswordMatch: true });
    }
  }

}
